<template lang="pug">
v-card.sdo-radius
  v-alert(
    color="success darken-1"
    flat
    text
    dark
  ).pa-9.ma-0
    div
      .mb-8
        h1 Вы аттестованы
        .caption Текущий статус
      p Поздравляем с успешным завершением курса.

    slot(name="slot" color="success")

</template>

<script>
// import { downloadFile, getFile } from '@/utils/base64';
import HintWrap from '@/components/HintWrap.vue';

export default {
  props: {
    enrollment: { type: Object, required: true },
  },
  data: () => ({
    upkSaved: null,
    editMode: true,
    diploma: null,
    loading: false,
    upkValues: {
      prior_record_id: null,
      whom: null,
      where: null,
    },
    fields: [
      {
        text: 'Кому',
        value: 'whom',
        component: 'v-textarea',
        component_attrs: {
          filled: true,
          rounded: true,
          rows: 1,
          'auto-grow': true,
        },
      },
      {
        text: 'Куда',
        value: 'where',
        component: HintWrap,
        component_attrs: {
          component: 'v-textarea',
          filled: true,
          rounded: true,
          rows: 1,
          'auto-grow': true,
          hintDescription: `Адрес, который мы сообщим службе "Почта России",
           в том числе индекс, для отправки удостоверения повышения квалификации`,
        },
      },
    ],
  }),
  computed: {
    showDiplomaDownload() {
      return [4, 5].includes(this.diploma?.status);
    },
  },
  async created() {
    this.fetchUPK();
  },
  methods: {
    // async fetchUPK() {
    //   const resp = await this.$api.enrollments.indexUPK({
    //     'search[prior_record_id]': this.enrollment.id,
    //     'search[owner_id]': this.$user.data.id,
    //   });
    //   const [upk] = resp.data.data;
    //   this.setUpk(upk);
    // },
    // setUpk(upk) {
    //   if (upk) {
    //     this.upkSaved = upk;
    //     Object.assign(this.upkValues, upk);
    //     this.editMode = false;
    //   }
    // },
    // sendUpk({ data, obs }) {
    //   if (this.upkSaved) {
    //     return this.$api.enrollments.updateUPK(this.upkSaved.id, {
    //       ...this.upkSaved,
    //       ...data,
    //     }, obs);
    //   }
    //   return this.$api.enrollments.createUPK({
    //     ...data,
    //     prior_record_id: this.enrollment.id,
    //   }, obs);
    // },
  },
};
</script>
